export default function () {
  const widgetName = 'circleCards';
  const widgetOpts = circleCardsOpts;

  const wrapContainerClass = 'circle-cards-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    moreButton: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`.${wrapContainerClass}`).remove();
      } else {
        createCustomCards(data.items);
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL } = widgetData[x];

      const $cardItem = $(this);
      $cardItem.append('<div class="image-container"></div>');
      $cardItem.find('.card-content').remove();
      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
           </div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }

      if (!URL && !Description) {
        $cardItem.addClass('empty-card').removeAttr('href');
      } else if (!URL && Description) {
        $cardItem.addClass('just-desc').removeAttr('href');
      } else if (URL && !Description) {
        $cardItem.addClass('only-url');
      }
    });
  }

  function isLocalUrl(urlToCheck) {
    const clientPath = SITEBASEURL;
    return urlToCheck !== null && urlToCheck.includes(clientPath);
  }
}
